import { Button, Grid } from '@mui/material'
import axios from 'axios'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import PageHeader from '../helper/PageHeader'
import { withTranslation } from 'react-i18next';
import { authContext } from '../../context/AuthContext'
import { englishCourseId, spanishCourseId } from '../../constants/global'

const SelectCourseZoom = props => {
    const history = useHistory()

    const userMain = useContext(authContext)
    const username = userMain.user.username

    const [englishCourse, setEnglishCourse] = useState(null)
    const [spanishCourse, setSpanish] = useState(null)

    const [currentCredit, setCurrentCredit] = useState((history.location.state && history.location.state.credit) || null)

    console.log("UserMain", userMain, "Credts", currentCredit)

    const mounted = useRef(true)


    useEffect(() => {
        async function getDetails() {
            const res = await await axios.all([
                axios.get('/api/course/'+englishCourseId),
                axios.get('/api/course/'+spanishCourseId)
            ])

            let newCurrentCred
            if (!currentCredit) {
                const res2 = await axios.get('/api/user/credit/' + username)
                newCurrentCred = res2.data.user.credit
            }

            if (mounted.current) {
                setEnglishCourse(res[0].data)
                setSpanish(res[1].data)
                if (newCurrentCred) {
                    console.log("Resetting credit amount")
                    setCurrentCredit(newCurrentCred)
                }

            }

        }

        getDetails()
        return () => mounted.current = false
    })


    // check if dvd or zoom, if so go to the code page. Otherwise open dialog for payment
    const onProceed = (data) => {
            const { id, label } = data.course
           // const modules = data.modules.map(e => ({ id: e.id, label: e.label, hyperlink: e.hyperlink }))

            const lang = (id === englishCourseId) ? 'English' : 'Spanish'
            history.push('/courses/Zoom/code', { id, lang, label/*, modules*/ })
    }

    return (
        <>
            <PageHeader
                title={props.t('trainingCourses.titleZoom')}
                cancel={history.goBack}
            />
           
            <br />
            <p>{props.t('trainingCourses.pleaseChoose')}</p>
            <Grid container direction="row" justifyContent="space-around" alignItems="center">
                <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    className={[].join(' ')}
                    onClick={() =>onProceed(englishCourse)}
                    >
                    {props.t('trainingCourses.english')}
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    className={[].join(' ')}
                    onClick={() =>onProceed(spanishCourse)}
                    >
                    {props.t('trainingCourses.spanish')}
                </Button>
            </Grid>
            <br/>
            <Grid container  justifyContent="space-around"  alignItems="center">
            <Grid item xs={12} md={8} style={{ textAlign: "left", alignSelf: "flex-start" }}>
                <ul>
                    <li> {props.t('trainingCourses.zoomDetail1')}</li>
                    <li> {props.t('trainingCourses.zoomDetail2')}</li>
                    <li> {props.t('trainingCourses.zoomDetail3')}</li>
                    <li> {props.t('trainingCourses.zoomDetail4')}</li>
                </ul>
            </Grid>
            </Grid>
        </>
    )
}

export default withTranslation()(SelectCourseZoom)

